import participationBackground from 'assets/images/contest/001_4x.webp';
import medalBackground from 'assets/images/contest/003_4x.webp';
import featuredBackground from 'assets/images/contest/004_4x.webp';
import signature from 'assets/images/contest/ass-luis_2x.webp';
import letrusLogo from 'assets/images/contest/logo-letrus_2x.webp';
import olympicsLogo from 'assets/images/contest/logo-olp_2x.webp';
import bronzeMedal from 'assets/images/contest/bronze_2x.webp';
import goldMedal from 'assets/images/contest/ouro_2x.webp';
import silverMedal from 'assets/images/contest/prata_2x.webp';

export const certificateAssets = {
  backgrounds: {
    participation: participationBackground,
    noScore: participationBackground,
    featuredComposition: featuredBackground,
    medal: medalBackground,
  },
  medals: {
    gold: goldMedal,
    silver: silverMedal,
    bronze: bronzeMedal,
  },
  signature,
  letrusLogo,
  olympicsLogo,
};
